module.exports = __webpack_public_path__ + "img/background-top.75bc32a5.jpg";